import React from 'react';
import Link from 'next/link';
import { UiIcon, UiTitle } from '@frontend/znanie-uikit';
import cn from 'classnames';
import { useReactiveVar } from '@apollo/client';

import { themeVar } from 'store/theme';
import { snakeToCamelCase } from 'utils/helpers';
import * as T from './LinkArrow.types';

import css from './LinkArrow.module.scss';

export const LinkArrow = ({
  title,
  href,
  handleClick,
  optionalClass = '',
  titleSize = 'big',
  testId,
}: T.ILinkArrowTypes) => {
  const { name: themeName } = useReactiveVar(themeVar);

  return (
    <Link
      href={href}
      className={cn(css.linkHeader, css[optionalClass])}
      data-testid={testId}
      onClick={handleClick}
    >
      <div className={css.headerWrapper}>
        <UiTitle
          className={cn(css.title, css[snakeToCamelCase(`title_${themeName}`)])}
          size={titleSize}
          as="h2"
        >
          {title}
        </UiTitle>
        <UiIcon className={css.arrow} name="arrow-forward-ios" />
      </div>
    </Link>
  );
};
